<template>
  <v-container class="employee-free-dates-controls-list__container">
    <v-card class="employee-free-dates-controls-list__card card">
      <v-card-text class="card__cells">
        <div
          ref="content"
          v-bind:style="{ maxHeight: isExpanded ? 'none' : maxHeight + 'px', overflow: 'hidden' }"
        >
          <slot />
        </div>
      </v-card-text>
      <v-card-actions class="card__action">
        <button
          type="button"
          v-if="contentOverflow"
          v-on:click="toggleContent"
          class="card__btn"
        >
          {{ isExpanded ? 'Скрыть' : 'Раскрыть' }}
        </button>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>

/**
 * @description Расширяемый блок.
 * @type {Vue}
 */
export default {
  data() {
    return {
      isExpanded: false,
      contentOverflow: false,
    };
  },
  methods: {
    /**
     * @description Переключить вид объекта.
     * @returns {void}
     */
    toggleContent() {
      this.isExpanded = !this.isExpanded;
    },
    /**
     * @description Проверить высоту блока с контентом.
     * @returns {void}
     */
    checkContentHeight() {
      const contentHeight = this.$refs.content.scrollHeight;
      this.contentOverflow = contentHeight > this.maxHeight;
    },
  },
  mounted() {
    this.checkContentHeight();
  },
  name: 'ExpandableBlock',
  props: {
    /**
     * @description Максимальная высота блока.
     * @type {Number}
     */
    maxHeight: {
      type: Number,
      default: () => 100,
    },
  },
};
</script>

<style scoped lang="scss">
.employee-free-dates-controls-list {
  &__container {
    padding: 0;
  }
  .card {
    box-shadow: none;
    &__cells {
      padding: 0;
      margin-bottom: 20px;
    }
    &__action {
      padding: 0;
    }
    &__btn {
      color: #0489E0;
    }
  }
}
</style>
